import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "fix-rep-wrapper" }
const _hoisted_2 = { class: "report-wrapper" }
const _hoisted_3 = { class: "fix-rep-left" }
const _hoisted_4 = { class: "fix-rep-legend" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "fix-rep-legend-text fix-report-timestamp" }, " Период ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "Физическое лицо", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "Время", -1)
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "fix-rep-loading" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, "Загружаем данные", -1)
const _hoisted_11 = {
  key: 1,
  class: "fix-report"
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "fix-report-timestamp" }
const _hoisted_14 = { class: "fix-report-row" }
const _hoisted_15 = {
  key: 0,
  class: "fix-report-row-dep"
}
const _hoisted_16 = { class: "fix-report-row org-pos org-pos-row" }
const _hoisted_17 = { class: "fix-report-row-org" }
const _hoisted_18 = {
  key: 0,
  class: "fix-report-row-dep"
}
const _hoisted_19 = { class: "fix-report-row act-type act-type-row" }
const _hoisted_20 = { class: "fix-report-row-org" }
const _hoisted_21 = { class: "fix-report-row-dep" }
const _hoisted_22 = {
  key: 0,
  class: "row-delimeter"
}
const _hoisted_23 = {
  key: 0,
  class: "fix-empty-after-filter"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", null, "Нет данных, соответствующих выбранным фильтрам", -1)
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = { key: 4 }
const _hoisted_27 = { class: "fix-rep-loading" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", null, "Загружаем данные", -1)
const _hoisted_29 = { class: "fix-rep-right" }
const _hoisted_30 = { class: "fix-rep-photo-block" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "fix-rep-photo-block-label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "" }, "Фотофиксация")
], -1)
const _hoisted_32 = {
  key: 0,
  class: "fix-rep-photo"
}
const _hoisted_33 = { key: 0 }
const _hoisted_34 = { class: "fix-rep-photo-error" }
const _hoisted_35 = ["src"]

import { reactive, onBeforeMount, watch, computed } from 'vue'
import {
  unitTimestampConvert,
  getMonthStartEnd,
  getUnixTimestamps,
  convertToSubFilterMap,
  exportToExcel,
  ExcelData
} from '@/globalFunctions'
import {
  Organization,
  Departments,
  Positions,
  Fix,
  Employee,
  SubFilterMap,
  Universal
} from '@/models'
import { Photo } from '@/classes'
import { useFixesStore } from '@/stores/fixes'
import { useCookesStore } from '@/stores/cookies'
import { eventBus } from '@/eventBus'
import { DatesMap } from '@/components/widgets/UFilters.vue'
import { useImagesYarosStore } from '@/stores/imagesYaros'

type ActionType = 'arrive' | 'leave'


export default /*#__PURE__*/_defineComponent({
  __name: 'FixRep',
  setup(__props) {

const state = reactive({
  reportData: [] as Fix[],
  orgName: '',
  organization: {} as Organization,
  departments: [] as Departments,
  positions: [] as Positions,
  imageRef: '',
  rowIndex: -1,
  actionLabel: 'Приход/Уход',
  actionSortArg: 'all',
  dataLoaded: false,
  periodStr: '',
  prevMonth: '',
  orgId: '',
  screenWidth: 0,
  prevDate: [] as Array<number>,
  isLoading: false,
  persons: [] as Employee[],
  showFilter: false,
  filterParams: {} as SubFilterMap,
  daysTimestamps: {} as DatesMap,
  filteredData: [] as ExcelData[],
  photo: new Photo(),
  filteredDepartment: ''
})

const imagesStore = useImagesYarosStore()
const imageSrc: Map<string, Photo> = new Map<string, Photo>()

const typeActMap: Record<ActionType, string> = {
  arrive: 'Приход',
  leave: 'Уход'
}

const fixes = useFixesStore()
const cookies = useCookesStore()

eventBus.on('filter', (obj) => {
  const validObj = convertToSubFilterMap(obj)
  if (validObj !== null) {
    state.filterParams = validObj
    rowClick(0, filteredData.value[0]?.photo)
  }
})

eventBus.on('reloadReport', async () => {
  await reloadFix()
})

eventBus.on('excelExport', () => {
  prepareDataForExport()
  exportToExcel(state.filteredData, 'fixes')
})

const filteredData = computed(() => {
  const filteredFixes = state.reportData
    .filter(item => filter(item))
    .sort((a, b) => b.time - a.time)
  return filteredFixes
})

const hasFilteredData = computed(() => {
  return filteredData.value.length > 0
})

function prepareDataForExport () {
  state.filteredData = state.reportData
    .filter(filter)
    .map(item => {
      return {
        Период: item.time ? unitTimestampConvert(item.time) : '',
        Подразделение: state.departments.find(dep => dep.id === item.depId)?.name || '',
        'Физическое лицо': item.perName,
        Должность: state.positions.find(pos => pos.id === item.posId)?.name || '',
        'Приход / Уход': typeActMap[item.type as ActionType],
        Время: item.time ? unitTimestampConvert(item.time, 'time') : ''
      }
    })
}

eventBus.on('showFilter', () => {
  state.showFilter = true
})

onBeforeMount(async () => {
  imageSrc.set('null', new Photo())
  state.screenWidth = window.innerWidth
  await loadingData()
  state.daysTimestamps = getUnixTimestamps()
})

watch(() => state.prevDate, (newValue) => {
  if (newValue.length > 0) {
    state.prevMonth = `${newValue[0].toString().padStart(2, '0')}.${newValue[1]}`
  }
})

function filterUniquePhotos (data: Fix[]): Fix[] {
  const seenPhotos = new Set<string>()
  return data.filter(item => {
    if (seenPhotos.has(item.photo)) {
      return false
    }
    seenPhotos.add(item.photo)
    return true
  })
}

async function loadingData () {
  state.reportData = JSON.parse(sessionStorage.getItem('fixes') || '[]')
  state.reportData = filterUniquePhotos(state.reportData)
  state.organization = JSON.parse(sessionStorage.getItem('organization') || '{}')
  state.orgName = state.organization.name
  const departmentsData = sessionStorage.getItem('departments')
  if (departmentsData) {
    state.departments = JSON.parse(departmentsData)
  }
  const positionsData = sessionStorage.getItem('positions')
  if (positionsData) {
    state.positions = JSON.parse(positionsData)
  }
  const persons = sessionStorage.getItem('persons')
  if (persons) {
    state.persons = JSON.parse(persons)
  }
  preparePeriod()
  state.dataLoaded = true
  if (state.reportData.length > 0) {
    rowClick(0, filteredData.value[0]?.photo)
  }
}

function preparePeriod () {
  const currentDate = new Date()
  const currMonth = currentDate.getMonth()
  const currYear = currentDate.getFullYear()
  const prevMonth = currMonth === 0 ? 11 : currMonth - 1
  const prevYear = currMonth === 0 ? currYear - 1 : currYear
  state.prevDate = [prevMonth + 1, prevYear]
  state.periodStr = `${prevMonth.toString().padStart(2, '0')}.${prevYear}-${(currMonth + 1).toString().padStart(2, '0')}.${currYear}`
}

async function rowClick (index: number, photoId: string) {
  if (photoId && state.imageRef !== photoId) {
    state.photo = new Photo()
    state.rowIndex = index
    state.imageRef = photoId

    if (!imageSrc.has(photoId)) {
      let result = ''
      try {
        let photo = new Photo()
        result = await imagesStore.getImage(state.organization.fixStorage, photoId, 200)
        if (result) {
          photo = new Photo(result, false, false)
        }
        imageSrc.set(photoId, photo)
        state.photo = photo
      } catch (error) {
        const errorPhoto = new Photo(result, false, result === '')
        imageSrc.set(photoId, errorPhoto)
        state.photo = errorPhoto
      }
    } else {
      state.photo = imageSrc.get(photoId) || new Photo()
    }
  }
}

function actionTypeSort () {
  const steps = ['all', 'arrive', 'leave']
  const stepsLen = steps.length
  const currStep = steps.findIndex(step => step === state.actionSortArg)
  if (stepsLen - 1 === currStep) {
    state.actionSortArg = steps[0]
    state.actionLabel = 'Приход/Уход'
  } else {
    state.actionSortArg = steps[currStep + 1]
    state.actionLabel = typeActMap[state.actionSortArg as ActionType]
  }
}

async function loadPrevMonth () {
  state.dataLoaded = false
  if (state.orgId === '') {
    await cookies.getCookie()
    state.orgId = cookies.getCookies.orgId
  }
  const prevMonth = state.prevDate[0]
  const year = state.prevDate[1]
  const prevMonthTimeStamp = getMonthStartEnd(prevMonth, year)
  await fixes.getFixesAction(state.orgId, null, prevMonthTimeStamp[0], prevMonthTimeStamp[1])
  state.reportData = [...state.reportData, ...fixes.getFixes]
  if (prevMonth - 1 === 0) {
    state.prevDate = [12, year - 1]
  } else {
    state.prevDate = [prevMonth - 1, year]
  }
  state.dataLoaded = true
}

async function reloadFix () {
  state.isLoading = false
  state.imageRef = ''
  const timestamps = getMonthStartEnd()
  if (state.orgId === '') {
    await cookies.getCookie()
    state.orgId = cookies.getCookies.orgId
  }
  await fixes.getFixesAction(state.orgId, null, timestamps[0], timestamps[1])
  sessionStorage.setItem('fixes', JSON.stringify(fixes.getFixes))
  await loadingData()
}

function filterSet (obj: SubFilterMap) {
  state.filterParams = obj
}

function filter (item: Fix) {
  if (Object.keys(state.filterParams).length === 0) {
    return true
  }
  const args = Object.keys(state.filterParams)
  if (args.includes('department') && state.filterParams.department.length > 0 &&
    item.depId !== state.filterParams.department) {
    return false
  }
  if (args.includes('position') && state.filterParams.position.length > 0 &&
    item.posId !== state.filterParams.position) {
    return false
  }
  if (args.includes('person') && state.filterParams.person.length > 0 &&
    item.perId !== state.filterParams.person) {
    return false
  }
  if (args.includes('date') && state.filterParams.date.length > 0) {
    let datesDiap : Array<number>
    if (typeof state.filterParams.date === 'string') {
      datesDiap = state.daysTimestamps[state.filterParams.date]
    } else {
      datesDiap = state.filterParams.date
    }
    if (datesDiap[0] > item.time ||
        datesDiap[1] < item.time) {
      return false
    }
  }
  return true
}

function filterByArray (array: Array<Universal>, type: string) {
  if (typeof array === 'string') return
  const arrLen = array.length
  if (arrLen === 0) return
  if (!Object.keys(state.filterParams).includes(type)) {
    state.filterParams = { ...state.filterParams, ...{ [type]: array[0].id } }
  } else {
    const ind = array.findIndex((dep) => dep.id === state.filterParams[type])
    if (ind + 1 === arrLen) {
      delete state.filterParams[type]
    } else {
      state.filterParams[type] = array[ind + 1].id
    }
  }
  eventBus.emit('filter', state.filterParams)
}

return (_ctx: any,_cache: any) => {
  const _component_u_spinner = _resolveComponent("u-spinner")!
  const _component_u_filters = _resolveComponent("u-filters")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("div", {
              class: "fix-rep-legend-block org-dep",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (filterByArray(state.departments, 'department')))
            }, [
              _createElementVNode("span", null, _toDisplayString(state.departments.find(dep => dep.id === state.filterParams.department)?.name ?? 'Подразделения'), 1)
            ]),
            _createElementVNode("div", {
              class: "fix-rep-legend-block org-pos",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (filterByArray(state.positions, 'position')))
            }, [
              _hoisted_6,
              _createElementVNode("span", null, _toDisplayString(state.positions.find(pos => pos.id === state.filterParams.position)?.name ?? 'Должность'), 1)
            ]),
            _createElementVNode("div", {
              class: "fix-rep-legend-block act-type button-click",
              onClick: actionTypeSort
            }, [
              _createElementVNode("span", null, _toDisplayString(state.actionLabel), 1),
              _hoisted_7
            ])
          ]),
          (!state.dataLoaded && state.reportData.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_u_spinner),
                  _hoisted_10
                ])
              ]))
            : _createCommentVNode("", true),
          (state.reportData.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredData.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", { key: index }, [
                    _withDirectives(_createElementVNode("div", {
                      class: _normalizeClass(['fix-rep-row-position', { 'fix-rep-row-margin-top': index !== 0 }]),
                      onClick: ($event: any) => (rowClick(index, item.photo))
                    }, [
                      _createElementVNode("div", {
                        class: _normalizeClass(['fix-rep-row fix-report-text button-click', { 'fix-rep-row-active': index === state.rowIndex }])
                      }, [
                        _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(unitTimestampConvert)(item.time)), 1),
                        _createElementVNode("div", _hoisted_14, [
                          (state.departments.find(org => org.id === item.depId)?.name)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(state.departments.find(org => org.id === item.depId)?.name), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("span", _hoisted_17, _toDisplayString(item.perName), 1),
                          (state.positions.find(pos => pos.id === item.posId)?.name)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(state.positions.find(pos => pos.id === item.posId)?.name), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("span", _hoisted_20, _toDisplayString(typeActMap[item.type as ActionType]), 1),
                          _createElementVNode("span", _hoisted_21, _toDisplayString(_unref(unitTimestampConvert)(item.time, 'time')), 1)
                        ])
                      ], 2),
                      (hasFilteredData.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_22))
                        : _createCommentVNode("", true)
                    ], 10, _hoisted_12), [
                      [_vShow, state.actionSortArg === 'all' || state.actionSortArg === item.type]
                    ])
                  ]))
                }), 128)),
                (!hasFilteredData.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, _hoisted_25))
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createElementBlock("div", {
                key: 2,
                class: "fix-rep-loading fix-rep-empty button-click",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (loadPrevMonth()))
              }, [
                _createElementVNode("span", null, _toDisplayString(`Нет данных за период ${state.periodStr}`), 1),
                _createElementVNode("span", null, _toDisplayString(`Нажмите для загрузки ${state.prevMonth}`), 1)
              ])),
          (state.reportData.length > 0 && state.dataLoaded)
            ? (_openBlock(), _createElementBlock("div", {
                key: 3,
                class: "fix-rep-loading fix-rep-empty button-click",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (loadPrevMonth()))
              }, [
                _createElementVNode("span", null, _toDisplayString(`Нажмите для загрузки ${state.prevMonth}`), 1)
              ]))
            : (!state.dataLoaded && state.reportData.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    _createVNode(_component_u_spinner),
                    _hoisted_28
                  ])
                ]))
              : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("div", _hoisted_30, [
            _hoisted_31,
            (state.reportData.length > 0 && hasFilteredData.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                  (state.photo.isError || state.photo.isLoading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                        _withDirectives(_createVNode(_component_u_spinner, null, null, 512), [
                          [_vShow, state.photo.isLoading]
                        ]),
                        _createElementVNode("div", _hoisted_34, [
                          _withDirectives(_createElementVNode("span", null, " Произошла ошибка при загрузке фото ", 512), [
                            [_vShow, state.photo.isError]
                          ])
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        class: "fix-rep-photo-image",
                        src: `data:image/jpeg;base64, ${state.photo.imageSrc}`
                      }, null, 8, _hoisted_35))
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    (state.showFilter)
      ? (_openBlock(), _createBlock(_component_u_filters, {
          key: 0,
          onClose: _cache[4] || (_cache[4] = ($event: any) => (state.showFilter = false)),
          onFilterSet: filterSet,
          settedFilters: state.filterParams
        }, null, 8, ["settedFilters"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})